import { BoxDetailBasicProps } from '@/box/interface'
import React, { Fragment } from 'react'
import { BoxDetailApn } from './apn'
import { BoxDetailConnection } from './connection'
import { BoxDetailNetMode } from './network/mode'
import { BoxDetailNetWan } from './network/wan'
import { BoxDetailNetWifi } from './network/wifi'
import { isGprs, isWifi } from './shared/Shared'
import { BoxDetailTime } from './time'

export const BoxDetailBasic: React.FC<BoxDetailBasicProps> = (
  props: BoxDetailBasicProps
) => {
  const { connection, netMode, wan, wifi, apn, time, subType } = {
    ...props.detailItem
  }

  const {
    detailItem,
    onNetworkModeUpdate,
    onNetworkUpdate,
    onApnUpdate,
    onConnectionUpdate,
    onTimeUpdate,
    onWifiScan
  } = props
  return (
    <Fragment>
      <BoxDetailNetMode
        title
        editItem={netMode}
        disabled={detailItem?.connectionState !== 1}
        subType={detailItem?.subType}
        onSave={onNetworkModeUpdate}
      />

      <BoxDetailNetWan
        title
        disabled={detailItem?.connectionState !== 1}
        editItem={wan}
        onSave={onNetworkUpdate}
      />

      <BoxDetailNetWifi
        title
        disabled={detailItem?.connectionState !== 1 || !isWifi(subType)}
        editItem={wifi}
        wifiItems={props.wifiItems}
        onSave={onNetworkUpdate}
        onWifiScan={onWifiScan}
      />

      <BoxDetailApn
        title
        disabled={detailItem?.connectionState !== 1 || !isGprs(subType)}
        editItem={apn}
        onSave={onApnUpdate}
      />

      <BoxDetailConnection
        title
        disabled={detailItem?.connectionState !== 1}
        editItem={connection}
        onSave={onConnectionUpdate}
      />

      <BoxDetailTime
        title
        disabled={detailItem?.connectionState !== 1}
        editItem={time}
        onSave={onTimeUpdate}
      />
    </Fragment>
  )
}
